import React, { useRef, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../auth";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const MyPhotoDialog = ({ open, onClose }) => {
  const { user, refresh } = useAuth();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true); setMsg(null);
    try {
      const fd = new FormData(); fd.append("file", file);
      await axios.post(`${API}/me/avatar`, fd);
      await refresh();
      setMsg({ ok: true, text: "✅ Foto enviada! Ela aparecerá no seu perfil após aprovação do administrador." });
    } catch (err) { setMsg({ ok: false, text: `❌ ${err?.response?.data?.detail || "Erro ao enviar foto"}` }); }
    setBusy(false); ref.current.value = "";
  };
  const cancel = async () => { await axios.delete(`${API}/me/avatar`); await refresh(); setMsg(null); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="my-photo-dialog">
        <DialogHeader>
          <DialogTitle className="font-fredoka text-2xl">Minha foto de perfil</DialogTitle>
          <DialogDescription>Envie uma nova foto. Ela será exibida após aprovação do administrador.</DialogDescription>
        </DialogHeader>
        {msg && <div data-testid="my-photo-msg" className={`p-3 rounded-2xl text-sm font-semibold ${msg.ok ? "bg-arc-success text-arc-text" : "bg-pink-100 text-arc-accent"}`}>{msg.text}</div>}
        <div className="flex items-center justify-center gap-6 py-2">
          <div className="text-center">
            <img src={user?.avatar} alt="" className="w-20 h-20 rounded-full bg-arc object-cover mx-auto" />
            <div className="text-xs text-arc-muted mt-1">Atual</div>
          </div>
          {user?.pending_avatar && (
            <div className="text-center" data-testid="my-photo-pending">
              <img src={user.pending_avatar} alt="" className="w-20 h-20 rounded-full bg-arc object-cover mx-auto ring-4 ring-yellow-300" />
              <div className="text-xs font-bold mt-1" style={{ color: "#C98F00" }}>Aguardando aprovação</div>
            </div>
          )}
        </div>
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="my-photo-input" />
        <button type="button" disabled={busy} onClick={() => ref.current.click()} className="arc-btn arc-btn-primary w-full" data-testid="my-photo-upload-btn">
          {busy ? "Enviando..." : "📷 Escolher nova foto"}
        </button>
        {user?.pending_avatar && <button type="button" onClick={cancel} className="arc-btn arc-btn-outline w-full" data-testid="my-photo-cancel-btn">Cancelar envio pendente</button>}
      </DialogContent>
    </Dialog>
  );
};
